export default theme => {
  return {
    drawerButton: {
      margin: 10,
      padding: 5,
      textAlign: 'center'
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/configuration/Pfizer/theme/components/scorecard/ScorecardView/ScorecardFooter.js